import { render, staticRenderFns } from "./RelatedOpportunityItem.vue?vue&type=template&id=daab88fc&scoped=true&lang=pug"
import script from "./RelatedOpportunityItem.vue?vue&type=script&lang=js"
export * from "./RelatedOpportunityItem.vue?vue&type=script&lang=js"
import style0 from "./RelatedOpportunityItem.vue?vue&type=style&index=0&id=daab88fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daab88fc",
  null
  
)

export default component.exports